import React from 'react'
import { array, object, string } from 'prop-types'

import Grid from '../Grid'
import Card from '../Card'
import Surround from '../Surround'
import Container from '../Container'
import Advert from '../Advert'
import Column from '@/component/Structure/Column'

import styles from './GridWithAdvert.module.scss'

const GridWithAdvert = ({
  articles,
  advertProps,
  advertLocation,
  pageData
}) => {
  if (!articles.length) return null
  const remainingArticles = articles.slice(1, 3)
  const imageRatio = 126 / 167

  return (
    <Container flex center>
      <Column trailingGap="mobile" column={{ width: 2, attributes: [] }}>
        <Surround bordered="desktop" padded="desktop">
          <Card
            typeConfig={{
              title: { size: 'heading4', themed: true }
            }}
            {...{
              ...articles[0],
              sizes: [
                '(min-width: 1420px) 326px',
                '(min-width: 960px) calc(25vw - 32px - 80px)',
                'calc((100vw - 80px) * 0.5)'
              ],
              width: 326
            }}
            imageRatio={imageRatio}
          />
        </Surround>
      </Column>
      <Column fixedWidth>
        {advertLocation === 'top' && (
          <div className={styles.AdvertWrapper}>
            <Advert {...advertProps} pageData={pageData} />
          </div>
        )}

        <Grid>
          {remainingArticles.map((article, i) => {
            return (
              <Grid.Item
                hidden={i > 1 ? 'mobile' : null}
                key={i}
                trailingGap={
                  i === 0 || (i === 1 && advertLocation === 'bottom')
                    ? 'default'
                    : undefined
                }
              >
                <Surround
                  padded={
                    i === 0
                      ? 'default'
                      : advertLocation === 'bottom'
                      ? 'desktop'
                      : null
                  }
                  bordered={
                    i === 0
                      ? 'default'
                      : advertLocation === 'bottom'
                      ? 'desktop'
                      : null
                  }
                >
                  <Card
                    typeConfig={{
                      title: {
                        size: ['body2', 'heading8'],
                        weight: 'medium',
                        themed: true
                      }
                    }}
                    horizontal
                    {...{
                      ...article,
                      description: '',
                      sizes: [
                        '(min-width: 1420px) 132px',
                        '(min-width: 960px) calc(12.5vw - 32px - 80px)',
                        'calc(50vw - 80px)'
                      ],
                      width: 132
                    }}
                    imageRatio={imageRatio}
                  />
                </Surround>
              </Grid.Item>
            )
          })}
        </Grid>
        {advertLocation === 'bottom' && (
          <Advert {...advertProps} pageData={pageData} />
        )}
      </Column>
    </Container>
  )
}

GridWithAdvert.propTypes = {
  articles: array,
  advertProps: object,
  advertLocation: string,
  pageData: object
}

export default GridWithAdvert
